// Cookie utilities for iOS PWA support
// Cookies persist between Safari and iOS PWA (unlike localStorage)

export function setCookie(name, value, days = 365) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  // Set cookie with path=/ and Secure flag for HTTPS
  // SameSite=None required for cross-origin, but we're same-origin so Lax is fine
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax${secure}`;
  console.log(`🍪 Cookie set: ${name}`);
}

export function getCookie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      const value = cookie.substring(nameEQ.length);
      console.log(`🍪 Cookie found: ${name}`);
      return value;
    }
  }
  
  console.log(`🍪 Cookie not found: ${name}`);
  return null;
}

export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  console.log(`🍪 Cookie deleted: ${name}`);
}
